import { isWorkspaceAgentSessionUnresolvableError } from '~/components/v2/components/workspace/workspace-agent-panel/utils/isWorkspaceAgentSessionUnresolvableError';

const MAX_TRANSIENT_SESSION_GET_FAILURES = 3;

export const shouldRetryPrivateWorkspaceAgentSessionGet = (failureCount: number, error: unknown): boolean => {
  if (isWorkspaceAgentSessionUnresolvableError(error)) {
    return false;
  }

  return failureCount < MAX_TRANSIENT_SESSION_GET_FAILURES;
};
